module.exports = __webpack_public_path__ + "static/media/timelapse_4.91754f03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_4.jpg
// module id = 964
// module chunks = 0